import { LazyCardsComponent } from '../component-library/CardsComponent.tsx/LazyCardsComponent'
import { LazyChartComponent } from '../component-library/ChartComponent'
import { LazyDataTableComponent } from '../component-library/DataTableComponent'
import { LazyFormComponent } from '../component-library/FormComponent'
import { TComponentConfig } from './types'

export function ComponentRenderer({ type, id }: TComponentConfig) {
  if (type === 'table') {
    return (
      <StandardContainer>
        <LazyDataTableComponent id={id} />
      </StandardContainer>
    )
  }
  if (type === 'form') {
    // return (
    //   <ScrollContainer>
    //     <LazyFormComponent id={id} />
    //   </ScrollContainer>
    // )
    return (
      <StandardContainer>
        <LazyFormComponent id={id} />
      </StandardContainer>
    )
  }
  if (type === 'vega-lite-chart') {
    return (
      <StandardContainer>
        <LazyChartComponent id={id} />
      </StandardContainer>
    )
  }
  if (type === 'card') {
    return (
      <StandardContainer>
        <LazyCardsComponent id={id} />
      </StandardContainer>
    )
  }
  return (
    <StandardContainer>
      <div className="flex flex-col gap-y-2">
        <span>Type: {type}</span>
        <span>Id: {id}</span>
      </div>
    </StandardContainer>
  )
}

// function ScrollContainer({ children }: { children: React.ReactNode }) {
//   return (
//     <div className="h-full w-full py-5 pl-4 pr-0">
//       <ScrollArea className="h-full w-[calc(100%-12px)]">{children}</ScrollArea>
//     </div>
//   )
// }

function StandardContainer({ children }: { children: React.ReactNode }) {
  return <div className="h-full w-full overflow-hidden p-5">{children}</div>
}
